// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import tools from '@fund/data';
import { market as config } from '../config';
import p from './public';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 7日年化
export default {

  // 格式化数据
  formatData: (row, buyAndSellPointData, timeName) => {
    let data = [];
    const rowData = row;
    // 数据缺值测试
    // const testIndex = 6;
    // delete rowData.Datas[testIndex].LJJZ;
    // delete rowData.Datas[testIndex].RATE;
    rowData.Datas = p().configureBuyAndRealData(row, buyAndSellPointData, timeName, 'FSRQ');
    // eslint-disable-next-line array-callback-return
    rowData.Datas.map(({ FSRQ, LJJZ, RATE }, index) => {
      let fData = {
        date: FSRQ,
        value: p().getDataWhenEmpty(rowData.Datas, index, 'LJJZ') - 0,
        type: '7日年化',
        rate: p().getDataWhenEmpty(rowData.Datas, index, 'RATE') - 0,
        real_value: tools.noData(LJJZ),
        real_rate: tools.noData(RATE),
        size: 2,
      };

      // 获取极坐标数据
      fData = p().formatPolarPoint(fData, index, rowData, 'FSRQ');

      // 设置变动点
      fData = p().setChangedPoint(fData, rowData);
      if (timeName === '近5年' || timeName === '成立来') {
        let nextdate = '';
        if (rowData.Datas.length > (index + 1)) {
          nextdate = rowData.Datas[index + 1].FSRQ;
        }
        // 设置买卖点
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, true, nextdate);
      } else {
        // 设置买卖点
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, false, '');
      }
      data = data.concat([
        {
          date: FSRQ,
          type: '一年定存',
          value: p().getDataWhenEmpty(rowData.Datas, index, 'RATE') - 0,
          rate: p().getDataWhenEmpty(rowData.Datas, index, 'RATE') - 0,
          real_value: tools.noData(LJJZ),
          real_rate: tools.noData(RATE),
          size: 1,
        },
        fData,
      ]);
    });

    return data;
  },

  // 绘制走势图
  drawChart(data, chart, alertTips, changeSlideState, isReDrawing, setLegend) {
    // 创建十字线组件
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = p().createToolTipsList(chart);
    const toolTipsList = {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };

    // 绘制走势图
    chart.source(data, p().sourceConfig);

    // 水印
    p().drawLogo(chart);

    chart.scale('value', {
      nice: true,
      max: p().getMaxVal(data),
    });

    chart.legend(false);
    chart.tooltip({
      ...p().tooltipConfig,
      yTip(val) {
        return {
          ...p().yTipsConfig,
          text: numeral(val).format('0.0000%', Math.trunc),
        };
      },
      onChange: (obj) => {
        p().tooltipOnChange();
        changeSlideState(true);

        const point = obj.items[0].origin;
        setLegend([
          point.real_value, // 0 7日年化
          point.real_rate, // 1 一年定存
        ]);

        // 显示十字线
        p().showToolTips(toolTipsList, obj.items[0], (val) => numeral(val).format('0.0000%', Math.trunc));
      },
      onHide: () => {
        p().tooltipOnHide();
        changeSlideState(false);

        // 隐藏十字线
        p().hideToolTIps(toolTipsList);
      },
    });

    chart.axis('value', {
      ...p().yAxisGridConfig,
      label: function label(text) {
        const cfg = {
          ...p().yAxisConfig,
          text: numeral(text).format('0.0000%', Math.trunc),
        };
        return cfg;
      },
    });

    chart.axis('date', {
      ...p().xAxisGridConfig,
      label: function label(text, index, total) {
        let textCfg = {
          text: text.substring(5),
        };
        if (index === 0) {
          textCfg.textAlign = 'left';
        } else if (index === total - 1) {
          textCfg.textAlign = 'right';
        } else {
          textCfg = null;
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });

    chart.line({ connectNulls: true }).position('date*value').color('type', config.colors7).size('size', [1, 2])
      .animate(false);

    // 画买卖点
    p().drawTradeMarker(data, chart);

    // 画变动点
    p().drawChangedMarker(data, chart, alertTips);

    // 设置极点提示
    p().drawPolarTips(data, chart, 'dateType:rate');

    chart.render();
  },
};
